import React from "react";
import SensorsPage from "./usertable";
import { getUserInfo } from "../../helpers/user";
import Error from "../error";
import AdminSensorsPage from "./admin";

const SensorsPageRouteWrapper = () => {
  const userInfo = getUserInfo();

  if (userInfo.role === "admin") {
    return <AdminSensorsPage />;
  } else if (userInfo.role === "org_admin" || userInfo.role === "user") {
    return <SensorsPage />;
  } else {
    return <Error />;
  }
};

export default SensorsPageRouteWrapper;
